import { Link } from "@tanstack/react-router";

import { Brand } from "./Brand";
import { OfflineState } from "./OfflineState";
import { ThemeToggle } from "./ThemeToggle";
import { buttonVariants } from "./ui/button";
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyTitle } from "./ui/empty";
import { Skeleton } from "./ui/skeleton";

export function OfflineShell() {
  return (
    <div className="offline-shell bg-background">
      <header className="offline-shell-header">
        <Brand />
        <ThemeToggle />
      </header>
      <main className="offline-shell-main" id="main-content" tabIndex={-1}>
        <OfflineState />
      </main>
    </div>
  );
}

export function LoadingShell({ suppressBrand }: { suppressBrand: boolean }) {
  return (
    <main
      aria-busy="true"
      className="grid min-h-dvh place-content-center justify-items-center gap-5 bg-background px-5 text-center"
    >
      <Brand suppressFallback={suppressBrand} />
      <Skeleton className="h-1.5 w-28" />
      <p className="text-sm text-muted-foreground">Opening your workspace…</p>
    </main>
  );
}

export function ErrorShell() {
  return (
    <main className="grid min-h-dvh place-items-center bg-background px-5 py-12">
      <Empty className="max-w-lg">
        <EmptyHeader>
          <Brand className="mb-5" />
          <EmptyTitle className="font-heading text-2xl">We couldn’t open CCBox.</EmptyTitle>
          <EmptyDescription>
            Refresh the page, or sign in again to start a new session.
          </EmptyDescription>
        </EmptyHeader>
        <EmptyContent>
          <Link className={buttonVariants({ variant: "default" })} to="/login">
            Return to sign in
          </Link>
        </EmptyContent>
      </Empty>
    </main>
  );
}
